import { gql } from '@apollo/client';

export default gql`
  query productionOrders {
    productionOrders {
      id
      customerState
      disableWarranty
      sendToClinic
      address
      patient {
        id
        firstName
        lastName
      }
      productionOrderItems {
        id
        name
        trackingNumber
        quantity
        trackingUrl
        deliveredAt
        eta
        labelUrl
        productionOrder {
          id
          disableWarranty
        }
        shippingCarrier {
          id
          name
        }
        product {
          id
          warrantyAllowed
        }
      }
      warrantyId
      warranties {
        id
        state
        hexCode
        createdAt
      }
    }
  }
`;
